(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["expedition_timer"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
    const now = new Date();
    const currentHour = now.getHours();
    const messageContainer = document.getElementById("expedition-message");
    const timerContainer = document.getElementById("expedition-timer");

    // Heure limite d'expédition (14h)
    const cutoff = new Date();
    cutoff.setHours(14, 0, 0, 0);

    // Message principal
    if (now < cutoff) {
      messageContainer.textContent = "📦 Commandez avant 14 h pour une expédition le jour même !";
    } else {
      messageContainer.textContent = "📦 Toute commande passée après 14 h sera expédiée le jour ouvré suivant.";
    }

    // Si moins de 4h avant 14h → afficher le compte à rebours
    const timeRemaining = cutoff - now;

    if (timeRemaining > 0 && timeRemaining <= 4 * 60 * 60 * 1000) {
      function updateTimer() {
        const now = new Date();
        const diff = cutoff - now;

        if (diff <= 0) {
          timerContainer.textContent = "⏱ Le délai pour une expédition le jour même est dépassé.";
          clearInterval(interval);
          return;
        }

        const hours = String(Math.floor(diff / (1000 * 60 * 60))).padStart(2, '0');
        const minutes = String(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');
        const seconds = String(Math.floor((diff % (1000 * 60)) / 1000)).padStart(2, '0');

        timerContainer.textContent = `⏱ Il reste ${hours}:${minutes}:${seconds} pour une expédition le jour même !`;
      }

      updateTimer();
      const interval = setInterval(updateTimer, 1000);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
